export enum PaymentForm {
  cash = 'cash',
  card = 'card',
  other = 'other',
  bonuses = 'bonuses',
}
